import { render, staticRenderFns } from "./TopUpWay.vue?vue&type=template&id=84612936&scoped=true&"
import script from "./TopUpWay.vue?vue&type=script&lang=js&"
export * from "./TopUpWay.vue?vue&type=script&lang=js&"
import style0 from "./TopUpWay.vue?vue&type=style&index=0&id=84612936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84612936",
  null
  
)

export default component.exports